import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { products } from "../dataList";

const GpsProductos = () => {
  const getData = () => {
    setListaProductos(products.filter((x) => x.tags.includes("gps")));
  };

  const [listaProductos, setListaProductos] = useState([]);
  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="main">
      <section className="servicios relative mt-5">
        <div className="section__title">
          <h2>Equipos y sistemas de GPS</h2>
        </div>

        <div className="servicios__container l-mw-90 l-grid repeat4">
          {listaProductos.map((item, index) => {
            return <ProductCard props={item} key={index} />;
          })}
        </div>
      </section>
    </div>
  );
};

export default GpsProductos;
